import { BaseFormat } from "./baseFormat";

export class NormalFormat extends BaseFormat {
  constructor(options = {}) {
    super(options);
    this.previewScale = options.previewScale ?? 0.5;
  }

  get tipo() {
    return "normal";
  }

  get canvasSize() {
    // 10x15cm a 300 DPI = 1182x1774px, reduzido por previewScale para exibição
    return {
      width: 1182 * this.previewScale,
      height: 1774 * this.previewScale,
    };
  }

  get scaleFinal() {
    return 1 / this.previewScale;
  }

  get supportsOrientation() {
    return true;
  }

  filterMolduras(listaMolduras, orientationId) {
    return listaMolduras.filter(
      (m) => m.dados.tipo === this.tipo && m.dados.orientacao === orientationId
    );
  }
}
